import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Scholenoverzicht',
    component: () => import(/* webpackChunkName: "scholenoverzicht" */ '../views/Scholenoverzicht/Scholenoverzicht.vue'),
  },
  {
    path: '/scholenzoeker',
    name: 'Scholenzoeker',
    component: () => import(/* webpackChunkName: "scholenzoeker" */ '../views/Scholenzoeker/Scholenzoeker.vue'),
  },
  {
    path: '/mbo',
    name: 'ScholenzoekerMbo',
    component: () => import(/* webpackChunkName: "scholenzoekerMbo" */ '../views/ScholenzoekerMbo/ScholenzoekerMbo.vue'),
  },
  {
    path: '/besturen',
    name: 'BesturenOverzicht',
    component: () => import(/* webpackChunkName: "besturenOverzicht" */ '../views/BesturenOverzicht/BesturenOverzicht.vue'),
  },
  {
    path: '/besturen/bestuur/:bgn',
    name: 'Bestuurpagina',
    component: () => import(/* webpackChunkName: "bestuurpagina" */ '../views/Bestuurpagina/Bestuurpagina.vue'),
  },
  {
    path: '/:schooltype/school/:brin',
    name: 'Schoolpagina',
    component: () => import(/* webpackChunkName: "schoolpagina" */ '../views/Schoolpagina/Schoolpagina.vue'),
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: () => import(/* webpackChunkName: "sitemap" */ '../views/Sitemap/Sitemap.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/scholenoverzicht',
  routes,
});

export default router;
